import { selector } from 'recoil';
import { validateSchema } from '@zurich/common/recoil';
import { paymentIntervalSchema, paymentWaySchema, } from '@zurich-client/validator/contract';
import { paymentIntervalSelector, paymentWaySelector } from './root';
export const paymentWayValidationSelector = selector({
    key: 'local/vehicle/validation/paymentWay',
    get: ({ get }) => {
        const paymentWay = get(paymentWaySelector);
        return validateSchema(paymentWaySchema, paymentWay);
    },
});
export const paymentIntervalValidationSelector = selector({
    key: 'local/vehicle/validation/paymentInterval',
    get: ({ get }) => {
        const paymentInterval = get(paymentIntervalSelector);
        return validateSchema(paymentIntervalSchema, paymentInterval);
    },
});
